module.exports = __webpack_public_path__ + "assets/img/gal_05.1f9a53ac.jpg";